export default __webpack_public_path__ + "static/media/sponsor-7.e28af19d.svg";